module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-06-e28057300f397e3814b94cf4d61ae7ae.jpg";